var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCommune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,39.8c-1,0-1.7-0.8-1.7-1.7V19c0-1,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7V38C13.1,39,12.4,39.8,11.4,39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.6,39.8c-1,0-1.7-0.8-1.7-1.7V19c0-1,0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7V38C50.3,39,49.6,39.8,48.6,39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,39.8c-1,0-1.7-0.8-1.7-1.7V26.1c0-1,0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7V38 C22.4,39,21.7,39.8,20.7,39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,39.8c-1,0-1.7-0.8-1.7-1.7V26.1c0-1,0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7V38C31.7,39,31,39.8,30,39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.3,39.8c-1,0-1.7-0.8-1.7-1.7V26.1c0-1,0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7V38C41,39,40.3,39.8,39.3,39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1,21.4c-0.6,0-1.2-0.3-1.5-0.9c-0.5-0.8-0.2-1.9,0.7-2.3L29.2,6.7c0.8-0.5,1.9-0.2,2.4,0.7 c0.5,0.8,0.2,1.9-0.7,2.3L9.9,21.2C9.6,21.3,9.4,21.4,9.1,21.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.9,21.4c-0.3,0-0.6-0.1-0.8-0.2L29.2,9.7c-0.8-0.5-1.1-1.5-0.7-2.3c0.5-0.8,1.5-1.1,2.4-0.7l20.9,11.5 c0.8,0.5,1.1,1.5,0.7,2.3C52.1,21.1,51.5,21.4,50.9,21.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,46.7H8.8c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7h42.3c1,0,1.7,0.8,1.7,1.7 C52.9,45.9,52.1,46.7,51.2,46.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.3,53.6H6.7c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7h46.5c1,0,1.7,0.8,1.7,1.7 C55,52.8,54.2,53.6,53.3,53.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommune);
export default __webpack_public_path__ + "static/media/ic_commune.c11e5b7eebf79d8a04fd6c84c8d8a7be.svg";
export { ForwardRef as ReactComponent };